import React from "react";
import styles from "./Pagination.module.css";
import {FiChevronLeft, FiChevronRight} from "react-icons/fi";

const Pagination = ({
                        currentPage,
                        totalPages,
                        onPageChange,
                        maxVisible = 3
                    }) => {
    if (totalPages <= 1) return null;

    const goTo = (p) => {
        if (p < 1 || p > totalPages || p === currentPage) return;
        onPageChange(p);
    };

// --- Генерация списка страниц с точками (fix: без дублей) ---
    const generatePages = () => {
        const pages = [];

        // Если страниц немного — точки не нужны
        if (totalPages <= maxVisible + 2) {
            for (let p = 1; p <= totalPages; p++) pages.push(p);
            return pages;
        }

        const half = Math.floor(maxVisible / 2);
        let start = currentPage - half;
        let end   = currentPage + half;

        // Базовые границы окна
        start = Math.max(start, 2);
        end   = Math.min(end, totalPages - 1);

        // Сдвиги у краёв
        if (currentPage <= half + 2) {
            start = 2;
            end = start + maxVisible - 1;
        } else if (currentPage >= totalPages - (half + 1)) {
            end = totalPages - 1;
            start = end - (maxVisible - 1);
        }

        // Финальный кламп — ВАЖНО: исключаем 1 и totalPages из середины
        start = Math.max(start, 2);
        end   = Math.min(end, totalPages - 1);

        // Левая граница
        pages.push(1);
        if (start > 2) pages.push("left-ellipsis");

        // Окно середины
        for (let p = start; p <= end; p++) pages.push(p);

        // Правая граница
        if (end < totalPages - 1) pages.push("right-ellipsis");
        pages.push(totalPages);

        return pages;
    };

    const pagesToShow = generatePages();

    return (
        <nav className={styles.paginationWrapper} aria-label="Каталог: пагинация">
            <button
                className={`${styles.arrowBtn} ${currentPage === 1 ? styles.disabled : ""}`}
                onClick={() => goTo(currentPage - 1)}
                aria-label="Предыдущая страница"
            >
                <FiChevronLeft />
            </button>

            {pagesToShow.map((item, idx) =>
                typeof item === "string" ? (
                    <span key={`ellipsis-${idx}`} className={styles.ellipsis}>…</span>
                ) : (
                    <button
                        key={`page-${item}-${idx}`} // фикс на случай повторов
                        className={`${styles.pageBtn} ${item === currentPage ? styles.active : ""}`}
                        onClick={() => goTo(item)}
                        aria-current={item === currentPage ? "page" : undefined}
                    >
                        <span className="body">{item}</span>
                    </button>
                )
            )}

            <button
                className={`${styles.arrowBtn} ${currentPage === totalPages ? styles.disabled : ""}`}
                onClick={() => goTo(currentPage + 1)}
                aria-label="Следующая страница"
            >
                <FiChevronRight />
            </button>
        </nav>
    );

};

export default Pagination;
